<template>
  <div id="app" style="background-color: #FAFAFA;">
    <div v-if="loading || pageLoading" class="loading-wrapper-class">
		<img src="@/assets/images/logo-new-dark.svg" alt="" width="225" class="mb-4">
		<div class="loader"></div>
    </div>
    <div :class="loading || pageLoading ? 'd-none' : ''">
      <Navbar/>

      <!-- adding styles for the space of the fixed navbar in the top of the page -->
      <router-view @loading="activatePageLoading" class="navbar-padding"/>
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
	components: {
		Navbar,
		Footer
	},

	data () {
		return {
			loading: false,
			pageLoading: false,
		}
	},

	methods: {
		activatePageLoading (value) {
			this.pageLoading = value
		}
	},

	created () {
		this.loading = true
		Promise.all([
			this.$store.dispatch('about/fetchAbout'),
			this.$store.dispatch('categories/fetchAllCategories'),
			this.$store.dispatch('contacts/fetchContacts')
		]).then(() => {
			this.loading = false
		})
	}
}
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import './scss/vars.scss';

/* Arabic Fonts */
@font-face {
  font-family: "arabic-font";
  src: url("~@/assets/fonts/Cairo-Regular.ttf") format("truetype");
  font-weight: normal;
}

@font-face {
  font-family: "arabic-font";
  src: url("~@/assets/fonts/Cairo-Medium.ttf") format("truetype");
  font-weight: 600;
}

// @font-face {
//   font-family: "arabic-font";
//   src: url("~@/assets/fonts/Ya-ModernPro-Bold.ttf") format("truetype");
//   font-weight: bold;
// }

@font-face {
  font-family: "arabic-font";
  src: url("~@/assets/fonts/Cairo-SemiBold.ttf") format("truetype");
  font-weight: 700;
}

@font-face {
  font-family: "arabic-font";
  src: url("~@/assets/fonts/Cairo-Bold.ttf") format("truetype");
  font-weight: 800;
}

/* English Fonts */
@font-face {
  font-family: "english-case";
  src: url("~@/assets/fonts/Poppins-Regular.ttf") format("truetype");
  font-weight: normal;
}

@font-face {
  font-family: "english-case";
  src: url("~@/assets/fonts/Poppins-Bold.ttf") format("truetype");
  font-weight: bold;
}

// navbar styles
.navbar-padding {
  padding-top: 114px;

  @media (max-width: 678px) {
    padding-top: 100px;
  }
  @media (max-width: 475px) {
    padding-top: 93px;
  }
}

// global styles
body {
  color: rgb(58, 65, 160); /* optional, for contrast */

}

* {
  font-family: 'arabic-font', 'english-case', 'sans-serif';
  font-weight: normal;
}
html[dir='ltr'] *:not(i) {
  font-family: 'english-case', 'arabic-font', sans-serif;
}

.pointer {
  cursor: pointer;
}

.bold {
  font-weight: 800;
}

.router-link-class {
  color: rgb(58, 65, 160) !important;
  text-decoration: none !important;
}

// button styles
.button {
  width: 156px;
  height: 45px;
  cursor: pointer;
  text-decoration: none;

  @media (max-width: 992px) {
    width: 200px;
    height: 60px;
  }

  transition: transform 0.15s ease, box-shadow 0.15s ease;
		&:hover {
			transform: translateY(-1px);
			box-shadow: -5px 2px 50px 3px #ebebeb;
		}
}
.tall-button {
  width: 200px;
  height: 40px;
  cursor: pointer;
  text-decoration: none;

  @media (max-width: 992px) {
    height: 50px;
  }

  transition: transform 0.15s ease, box-shadow 0.15s ease;
		&:hover {
			transform: translateY(-1px);
			box-shadow: -5px 2px 50px 3px #ebebeb ;
		}
}

.dark-blue-color {
  color: rgb(58, 65, 160);
}

html[dir = 'ltr'] .tall-button {
  width: 250px;
  height: 40px;
  cursor: pointer;

  @media (max-width: 992px) {
    width: 275px;
    height: 50px;
  }

  transition: transform 0.15s ease, box-shadow 0.15s ease;
		&:hover {
			transform: translateY(-1px);
			box-shadow: -5px 2px 50px 3px #ebebeb ;
		}
}

.short-button {
  width: 130px;
  height: 45px;
  cursor: pointer;
  text-decoration: none;

  transition: transform 0.15s ease, box-shadow 0.15s ease;
		&:hover {
			transform: translateY(-1px);
			box-shadow: -5px 2px 50px 3px #ebebeb ;
		}
}

.first-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 75px;
  background-color: $secondary;
  color: white;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;

  @media (max-width: 992px) {
    font-size: 16px;
  }
}

.second-button {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 75px;
  border: 2px solid $secondary;
  background-color: white;
  color: $secondary;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;

  @media (max-width: 992px) {
    font-size: 16px;
  }
}

.card-shadow {
  box-shadow: 0px 0px 15px 20px rgba(230, 229, 229, 0.1)
}

// all widthes
.w-5   { width: 5%; }
.w-10  { width: 10%; }
.w-15  { width: 15%; }
.w-20  { width: 20%; }
.w-30  { width: 30%; }
.w-35  { width: 35%; }
.w-40  { width: 40%; }
.w-45  { width: 45%; }
.w-55  { width: 55%; }
.w-60  { width: 60%; }
.w-65  { width: 65%; }
.w-70  { width: 70%; }
.w-80  { width: 80%; }
.w-85  { width: 85%; }
.w-90  { width: 90%; }
.w-95  { width: 95%; }

// all heights
.h-5   { height: 5%; }
.h-10  { height: 10%; }
.h-15  { height: 15%; }
.h-20  { height: 20%; }
.h-30  { height: 30%; }
.h-35  { height: 35%; }
.h-40  { height: 40%; }
.h-45  { height: 45%; }
.h-55  { height: 55%; }
.h-60  { height: 60%; }
.h-65  { height: 65%; }
.h-70  { height: 70%; }
.h-80  { height: 80%; }
.h-85  { height: 85%; }
.h-90  { height: 90%; }
.h-95  { height: 95%; }

// text align styles
// text-start
.text-start {
  text-align: start !important;
}

.text-sm-start {
  text-align: start !important;
}

.text-md-start {
  text-align: start !important;
}

.text-lg-start {
  text-align: start !important;
}

.text-xl-start {
  text-align: start !important;
}

.text-sm-start {
  text-align: start !important;
}

.text-sm-start {
  text-align: start !important;
}

// text end
.text-end {
  text-align: end !important;
}

.text-sm-end {
  text-align: end !important;
}

.text-md-end {
  text-align: end !important;
}

.text-lg-end {
  text-align: end !important;
}

.text-xl-end {
  text-align: end !important;
}

.text-sm-end {
  text-align: end !important;
}

.text-sm-end {
  text-align: end !important;
}

.loading-wrapper-class {
	width: 100vw;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 35px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 6px solid #514b82;
  animation:
    l20-1 0.8s infinite linear alternate,
    l20-2 1.6s infinite linear;
}
@keyframes l20-1{
   0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
   12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
   25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
   50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
   75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
   100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
}
@keyframes l20-2{
  0%    {transform:scaleY(1)  rotate(0deg)}
  49.99%{transform:scaleY(1)  rotate(135deg)}
  50%   {transform:scaleY(-1) rotate(0deg)}
  100%  {transform:scaleY(-1) rotate(-135deg)}
}

</style>
